import React from "react";
import Classes from "./styles/style.module.css";
import HomeIcon from "../../images/icons/home.svg";
import HomeIconActive from "../../images/icons/home-filled.svg";
import UserIcon from "../../images/icons/Person.svg";
import UserIconActive from "../../images/icons/Person-filled.svg";
import NotificationsIcon from "../../images/icons/blogger.svg";
import NotificationsActive from "../../images/icons/blogger-filled.svg";
import BlogIconActvie from "../../images/icons/notification-status-active.svg";
import BlogIcon from "../../images/icons/notification-status.svg";
import { useLocation, useNavigate } from "react-router";
import useHomeAddress from "../../Hooks/getHomeAddress";

const getRouteIcon = (route, isActive) => {
  switch (route) {
    case "/profile":
      return <img src={isActive ? UserIconActive : UserIcon} alt="profile" />;
    case "/":
      return (
        <img
          src={isActive ? NotificationsActive : NotificationsIcon}
          alt="home"
        />
      );
    case "/dashboard":
      return <img src={isActive ? HomeIconActive : HomeIcon} alt="dashboard" />;
    case "/blog":
      return <img src={isActive ? BlogIconActvie : BlogIcon} alt="blog" />;
    default:
      break;
  }
};

const getRouteName = (route) => {
  switch (route) {
    case "/profile":
      return <p>کاربر</p>;
    case "/":
      return <p>اعلان ها</p>;
    case "/dashboard":
      return <p>پیشخوان</p>;
    case "/blog":
      return <p>اخبار</p>;
    default:
      break;
  }
};

const FooterItem = ({ route, disabled, hasNew, id }) => {
  const { homeAddress } = useHomeAddress();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (route) => {
    if (!disabled) {
      if (route === "/") {
        navigate(homeAddress);
      } else {
        navigate(route);
      }
      if (route === "/blog" && id !== "") {
        localStorage.setItem("lastBlog", id);
      }
    }
  };
  return (
    <div
      className={`${Classes.footerItem} ${
        location.pathname === route ? Classes.active : ""
      }`}
      onClick={() => handleNavigate(route)}
    >
      {hasNew && <div className={Classes.new}></div>}
      {getRouteIcon(route, location.pathname === route)}
      {getRouteName(route)}
    </div>
  );
};

export default FooterItem;
